import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["underline"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_GradientText = _resolveComponent("GradientText")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["reasoning-head pointer", {completed: $props.completed}]),
    underline: $props.completed ? '' : null
  }, [
    ($props.completed)
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          class: "spark-icon",
          icon: "spark-1",
          size: "1.6rem",
          stroke: "var(--brand-700)"
        }))
      : (_openBlock(), _createBlock(_component_Icon, {
          key: 1,
          class: "spark-icon",
          icon: "animated/thinking-asterisk",
          width: "1.6rem",
          height: "1.6rem",
          external: ""
        })),
    ($props.completed)
      ? (_openBlock(), _createBlock(_component_Ellipsis, {
          key: 2,
          class: "title"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.title), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }))
      : (_openBlock(), _createBlock(_component_GradientText, {
          key: 3,
          hoverable: false,
          hover: "",
          horizontal: "",
          transparent: "",
          duration: "1.5s",
          class: "title"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Ellipsis, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.title), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })),
    _createVNode(_component_Icon, {
      class: "chevron-icon",
      icon: $props.open ? 'chevron-up' : 'chevron-down',
      size: "1.6rem",
      stroke: "var(--gray-600)"
    }, null, 8 /* PROPS */, ["icon"])
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}